import { takeEvery }          from 'redux-saga/effects';
import { api }                from 'apps/api'
import { SAVE, DESTROY, GET } from 'apps/action_types';
import { connect }            from './connect';

export const save = function*(){
  let settings = {
    apiMethod: api.save
  }
  yield takeEvery(SAVE, connect(settings))
}

export const destroy = function*(){
  let settings = {
    apiMethod: api.destroy
  }
  yield takeEvery(DESTROY, connect(settings))
}

export const get = function*(){
  let settings = {
    apiMethod: api.get
  }
  yield takeEvery(GET, connect(settings))
}
